// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2501":"f84896fb","4385":"5f7fa9df"}[chunkId] + ".chunk.css";
};